'use client'
import { Col } from '@repo/ui/components'
import { AccountContainer } from './account'
import { SettingsContainer } from './settings'
import { PublicProfileContainer } from './public-profile'

export const ProfileContainer = () => {
  return (
    <Col className='gap-md max-w-[720px] '>
      <PublicProfileContainer />
      <AccountContainer />
      <SettingsContainer />
    </Col>
  )
}
